module.exports = __webpack_public_path__ + "static/media/next-arrow-active.fc8dbaac.svg";